import React, { useState, useRef } from 'react'
import { auth, storage } from '../firebase';

const Profile = ({setUserName, userName, profilePic, setProfilePic}) => {
  const [input, setInput] = useState('')
  const [message, displayMessage] = useState(false)
  const [alert, displayAlert] = useState(false)
  const [load, setLoad] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!input) {
      displayAlert(true)
      displayMessage(false)
    } else {
      displayAlert(false)
      displayMessage(true)
      setUserName(input)
    }
  }

  const hiddenFileInput = useRef(null);
  const handleClick = (e) => {
    e.preventDefault()
    hiddenFileInput.current.click();
  }
  const handleChange = event => {
    const file = event.target.files[0];
    setLoad(!load)
    storage.ref('users/' + auth.currentUser.uid + '/profile.jpg').put(file).then(() => {
      console.log('Successfully uploaded!')
      auth.onAuthStateChanged(user => {
        if(user) {
          storage
          .ref('users/' + auth.currentUser.uid + '/profile.jpg')
          .getDownloadURL()
          .then((imgURL) => {
            setProfilePic(imgURL)
            setLoad(false)
          });
        }
      })
    }).catch(error => {
      console.log('Error: ', error.message)
    })
  };

  const loadText = (
    <div className="profile__form--load">
      <span>Uploading picture...</span>
    </div>
  )

  const updateText = (
      <div className="profile__form--confirm">
        &#10003; User Name Updated
      </div>
    )

  const alertText = (
    <div className="profile__form--alert">
      <span>Error - Invalid Input!</span>
    </div>
  )
  
  return (
    <>
      <div className="profile">
        <h3 className="profile__heading">{userName ? userName + "'s" : "Ryan's"} Profile</h3>
        <form className="profile__form" onSubmit={handleSubmit}>
          <div className="profile__form--top">
            <span className="profile__form--label">
              Set User Name:
            </span>
            {alert && alertText}
            {message && updateText}
          </div>
          <div className="profile__form--bottom">
            <input 
              className="profile__form--input" 
              type="text" 
              placeholder="User Name" 
              onChange={e => setInput(e.target.value)}
            />

            <button 
              className="profile__form--button" 
              type="submit">
                Save
            </button>
          </div>
        <span className="profile__form--label">Set Profile Photo:</span>
        <div className="profile__photo">
          <img className="profile__photo--img" src={profilePic || 'https://i.stack.imgur.com/34AD2.jpg'} alt="profile"/>
          <div>
            {load && loadText}
            <button
              className="profile__photo--btn" 
              onClick={handleClick}>
              Upload a file
            </button>
          </div>
        <input
          type="file"
          ref={hiddenFileInput}
          onChange={handleChange}
          style={{display: 'none'}} 
          />
        </div>
        </form>
      </div>
    </>
  )
}

export default Profile
